import { render, staticRenderFns } from "./CreateRbuSectionDialog.vue?vue&type=template&id=2def5dc8"
import script from "./CreateRbuSectionDialog.vue?vue&type=script&lang=js"
export * from "./CreateRbuSectionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports